export default __webpack_public_path__ + "media/images/icons/icon-profile-86a74e5bb07d708fb34b739f98208c2f.svg";